module.exports = __webpack_public_path__ + "static/media/difdisplay-webfont.4f440265.ttf";